
    
<template>
    <!-- PC端 -->
	<el-container v-if="!GLOBAL.isMobile" class="container">
        <div class="header flex">
            <!-- 左侧logo -->
            <div class="logo">
               <router-link to="/" tag="img" src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/logo_s.png" alt="自动洗车机洗车"></router-link>
             </div>
             <!-- 右侧导航 -->
            <div class="nav-box" v-cloak>
                <div :class="['nav-item index-nav', navActiveClass(item)]" v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                    <router-link :to="item.path" class="first-nav">
                        <span>{{item.name}}</span>
                    </router-link>
                    <div class="second-nav-box" v-if="item.children && (item.children.length > 0) && !(item.children.length == 1 && item.children[0].path == item.path)">
                        <div v-for="(children, index) in item.children" v-if="item.path != children.path" :to="children.path" :class="$route.path == children.path ? 'second-nav active': 'second-nav'" @click.self="toRobot(children.path)">
                            <span @click.self="toRobot(children.path)">{{children.name}}</span>
                            <div class="third-nav-box" v-if="children.navs">
                                <div v-for="(nav, index) in children.navs" :class="index == eventBus.modelIndex ? 'third-nav active' : 'third-nav'" @click.stop="showThisRobot(index)">
                                    <span>{{nav}}</span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <!-- 导航栏 -->
            <!-- <el-col  class="top-menu flex">
                <el-menu 
                    :default-active="$route.path" 
                    mode="horizontal" 
                    text-color="#373636"
                    active-text-color="#E30B1B"
                    class="el-menu-vertical-demo" 
                    unique-opened 
                    router>
                    <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                        <el-submenu :index="index+''" v-if="!item.leaf">
                            <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if = "item.leaf && item.children.length > 0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
                    </template>
                </el-menu> -->
                <!-- <router-link v-if="!userId" tag="div" to="/login" class="login-box">登录</router-link> -->
                <!-- <router-link v-if="!sessionStorage.getItem('userId')" tag="div" to="/login" class="login-box">登录</router-link> -->
                <!-- <el-dropdown v-else trigger="hover">
                    <span class="el-dropdown-link"><img class="user-icon" :src="'nav/icon_nav_ personal.png' | imgsrc" /></span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided >
                            <router-link tag="p" to="/userInfo">个人资料</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item divided @click.native="clickLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </el-col>
        </div>


		<router-view></router-view>	
        <el-footer :span="24" class="footer">
            <div class="contact">
                <div class="left">
                    <div class="link-box">
                        <span class="item"><router-link to="/">产品介绍</router-link></span>
                        <span class="item"><router-link to="/buyGuide">选购指南</router-link></span>
                        <span class="item"><router-link to="/operMarket">运营支持</router-link></span>
                        <span class="item"><router-link to="/afterSale">售后支持</router-link></span>
                        <span class="item"><router-link to="/about">走进太仆</router-link></span>
                        <!-- <span class="item"><router-link to="/taipuFuture">太仆未来</router-link></span> -->
                        <span class="item"><router-link to="/cityPartners">城市合伙人</router-link></span>
                    </div>
                    <div class="address-box">
                        <div class="logo footer-tplogo">
                            <router-link to="/">
                                <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/logo_s.png" />
                            </router-link>
                        </div>
                        <div class="address">
                            <div class="text">
                                公司地址：浙江省杭州市余杭区五常街道165号靖源国际4幢8楼
                            </div>
                            <div class="text">
                                电子邮箱：tpqc@taipuauto.cn
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="bundle">
                        <div class="phone">全国加盟热线：<span class="strong">400-666-1098</span></div>
                        <div class="ex-link-box">
                            <div class="ex-link">
                                <img class="icon" src="http://cdn.taipuauto.cn/website/footer/icon_wx.png" />
                                <!-- <div class="qr-code">
                                    <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/operation_applets_QR.png">
                                </div> -->
                            </div>
                            <div class="ex-link">
                                <img class="icon" src="http://cdn.taipuauto.cn/website/footer/icon_wb.png" />
                                <!-- <div class="qr-code">
                                    <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/Bottom_erweima%402x.png">
                                </div> -->
                            </div>
                            <div class="ex-link" id="footer-icon-sh">
                                <img class="icon" src="http://cdn.taipuauto.cn/website/footer/icon_sh.png" />
                            </div>
                            <div class="ex-link" id="footer-icon-tt">
                                <img class="icon" src="http://cdn.taipuauto.cn/website/footer/icon_tt.png" />
                            </div>
                        </div>
                    </div>
                    <img class='icon-img' src="http://cdn.taipuauto.cn/website/footer/icon_gzh.png"/>
                    <img class='icon-img' src="http://cdn.taipuauto.cn/website/footer/icon_yyx.png"/>
                </div>
            </div>
            <div class="copyright">
                <a href='https://beian.miit.gov.cn' target="blank"><span class="text">2016-2025Aliyun.com 版权所有 浙ICP备16017440号-1</span></a>
                
            </div>
        </el-footer>

        <!-- 侧边悬浮标签 -->
        <div id="overflow-tag">
            <div class="each-tag service-tag">
                <div class="right-box">
                    <img :src=" 'sideBtn/wx_logo.png' | imgsrc" alt="">
                    <p class='name'>立即咨询</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content kf">
                    <img :src="'sideBtn/kfwx_qrcode.png' | imgsrc" alt="">
                    <p class='tip'>添加客服微信</p>
                </div>
            </div>

            <div class="each-tag bdkf-tag">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/zixun_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/zixun_red.png' | imgsrc" alt="">
                    <p class='name'>在线咨询</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content bdkf">
                    <div class='white'>
                        <p class='tip'>在线客服为您一对一进行解答</p>
                        <p class='tip btn' @click='handleOpenBdkf'>点击咨询</p>
                    </div>
                    
                </div>
            </div>
        
            <div class="each-tag phone-tag">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/phone_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/phone_red.png' | imgsrc" alt="">
                    <p class='name'>联系我们</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content phone">
                    <p class='bold'>拨打客服热线了解更多信息</p>
                    <p class='tip'><span>服务热线：</span>400-666-1098</p>
                    <p class='tip'><span>服务时间：</span>7*24小时</p>
                </div>
            </div>
            <div class="each-tag follow-tag">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/guanzhu_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/guanzhu_red.png' | imgsrc" alt="">
                    <p class='name'>关注我们</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content follow">
                    <div class="each-qrcode fl">
                        <img :src="'sideBtn/gzh_qrcode.png' | imgsrc" alt="">
                        <p class='tip'>关注微信公众号</p>
                        <p class='tip'>获取最新行业资讯</p>
                    </div>
                    <div class="each-qrcode fr">
                        <img :src="'sideBtn/dy_qrcode.jpg' | imgsrc" alt="">
                        <p class='tip'>关注抖音</p>
                        <p class='tip'>获取最新行业资讯</p>
                    </div>
                </div>
            </div>
           
            <div class="each-tag back-to-top"  @click="scrollToTop">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/top_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/top_red.png' | imgsrc" alt="">
                </div>
               
            </div>

        </div>
	</el-container>

    <!-- 手机端 -->
	<el-container v-else class="container-m">
		<el-row  class="header-box"  type="flex" justify="space-between">
            <div class="icon-box" @click="showMenu = true">
                <img src="http://tp-app.img-cn-hangzhou.aliyuncs.com//ios/1562054615458_menu.png" alt="" class="icon">
            </div>
            <div class="current-nav">{{pageName}}</div>
            <!-- <img src="'nav/m_nav_logo.png' | imgsrc" alt="" class="logo"> -->
            <div class="icon-box">
                <!-- <router-link v-if="!userId" tag="div" to="/login" class="no-login">登录</router-link> -->
                <!-- <router-link v-if="!sessionStorage.getItem('userId')" tag="div" to="/login" class="no-login">登录</router-link> -->
                <!-- <el-dropdown v-else trigger="click">
                    <span class="el-dropdown-link"><img class="user-icon" :src="'nav/icon_nav_ personal.png' | imgsrc" /></span>
                    <el-dropdown-menu slot="dropdown" class="mobile-userinfo-menu">
                        <el-dropdown-item divided @click.native="">
                            
                            <router-link tag="p" to="/userInfo">个人资料</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item divided @click.native="clickLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>

            <!-- 导航栏 -->
            <div v-show="showMenu"  class="side-menu-box" @click.stop="showMenu = false">
                <div class="side-menu">
                    <router-link tag="div" to="/" class="top-logo flex">
                        <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/menu_logo%402x.png" alt="">
                    </router-link>
                    <el-menu 
                        :default-active="$route.path" 
                        text-color="#888888"
                        class="el-menu-vertical-demo" 
                        unique-opened 
                        router>
                        <template v-for="(item,index) in $router.options.routes">
                            <el-menu-item :index="item.path" v-if="item.name">{{item.name}}</el-menu-item>
                        </template>
                    </el-menu>
                </div>
            </div>

		</el-row>

        <transition  name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

        <el-footer class="footer" style="height: auto;">
            <div class="tpLogo">
                <img src="http://tp-app.img-cn-hangzhou.aliyuncs.com/ios/nav_logo_footer.png" alt="一台洗车机多少钱">
            </div>
            <div class="link">
                <router-link to="/">产品介绍</router-link>
                <div class="line"></div>
                <router-link to="/operMarket">运营支持</router-link>
                <div class="line"></div>
                <router-link to="/afterSale">售后支持</router-link>
                <div class="line"></div>
                <router-link to="/about">走进太仆</router-link>
                <div class="line"></div>
                <router-link to="/taipuFuture">太仆未来</router-link>
                <div class="line"></div>
                <router-link to="/cityPartners">城市合伙人</router-link>
            </div>
            <div class="qrcode">
                <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/yyzc_img_ptzc_qr@2x.png" alt="自动洗车">
                <img src="https://tp-app.oss-cn-hangzhou.aliyuncs.com/ios/yyzc_img_llzh_qr@2x.png" alt="自动洗车">
                <div class="phone">
                    <p class="desc">全国统一招商热线：</p>
                    <p class="text">400-666-1098</p>
                </div>
            </div>
            <div class="address">
                公司地址：浙江省杭州市余杭区五常街道165号靖源国际4幢8楼
            </div>
            <div class="email">
                电子邮箱：tpqc@taipuauto.cn
            </div>
            <div class="copyright">
                <p>2016-2025Aliyun.com 版权所有 浙ICP备16017440号-1</p>
            </div>
        </el-footer>
	</el-container>

</template>

<script>
    import GLOBAL from '@/assets/js/global.js'
    import { logout } from '@/api/api.js'
    import { EventBus } from '@/common/js/event-bus.js'
	export default {
		data() {
			return {
                userId: '',  //用户信息，登陆后
                showMenu: false,  //手机是否隐藏菜单
                pageName: '太仆科技',
                eventBus: EventBus
			}
        },
       
		methods: {
			
			//退出登录
			clickLogout: function () {
                var that = this;
                logout({}).then(res => {
                    if (res.code == '200') {
                        sessionStorage.clear();
                        that.userId = sessionStorage.getItem('userId') || '';
                        if (that.$route.path == '/userInfo') {
                            that.$router.push({ path: '/login' })
                        }
                    }
                })
			},
            scrollToTop: function () {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            handleOpenBdkf: function() {
                document.querySelector('#nb_icon_wrap').click()
            },

            toRobot: function(path) {
                this.$router.push({ path })
            },

            showThisRobot: function(index) {
                console.log('showThisRobot: ', this.$router,this.$route,  this.$route.path == '/robot/c')
                if (this.$route.path == '/robot/c') {
                    EventBus.changeModelIndex(index)
                } else {
                    this.$router.push({ path: `/robot/c?index=${index}` })
                }
            },

            navActiveClass: function(nav) {
                // console.log('navActiveClas:', nav, this.$router.currentRoute.matched[0].path, this.$router.currentRoute.matched)
                // 顶部导航目前只有两层，下面按两层写死
                let currentPath = this.$router.currentRoute.matched[0].path || this.$router.currentRoute.matched[1].path
                let selfActive = false
                let childrenActive = false
                if(currentPath == nav.path){
                    selfActive = true
                } else {
                    for (let item of nav.children) {
                        if(currentPath == item.path){
                            childrenActive = true
                            break
                        }
                    }
                }
                return `${selfActive ? 'self-active':''} ${childrenActive ? 'child-active':''}`
            },

            setPageName: function() {
                console.log('setPageName: ', this.$router.currentRoute.matched, this.$router)
                this.pageName = this.$router.currentRoute.matched[0].name
            }
		},
		mounted() {
            this.userId = sessionStorage.getItem('userId') || '';
            // console.log('{{$this.$router.currentRoute}}', this.$router.currentRoute)
		},

        computed: {
            // navActiveClass: function (item) {
            //     // let routes = this.$router.options.routes
            //     // for 
            //     // return {
                    
            //     // }
            //     console.log('navActiveClas:', arguments)
            // }
        },
        
        watch: {
            '$route': 'setPageName'
        }
	}
</script>

<style lang="scss">
	.container {
		position: relative;
		top: 0;
		bottom: 0;
		width: 100%;
        // padding-top: 64px;
        .el-carousel--horizontal {
            padding-top: 64px;
        }
        .header {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 64px;
            background: #080808;
            padding: 0 60px;
            box-sizing: border-box;
            position: fixed;
            z-index: 100;
            a:link, a:active, a:visited ,a:hover {
                color:#FFFFFF;
            }
            .logo {
                width: 103.24px;
                height: 17.69px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                &:hover {
                    cursor: pointer;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .nav-box {
                font-size:14px;
                color:rgba(255,255,255,1);
                display: flex;
                position: absolute;
                right: 0;
                height: 64px;
                .nav-item {
                    width: 120px;
                    text-align: center;
                    // background: white;
                    position: relative;
                    &.self-active {
                        .first-nav {
                            font-weight: 600;
                            border-bottom: 2px solid #E30B1B;
                        }
                        &:hover {
                            font-weight: 600;
                            .second-nav-box{
                                font-weight: 400;
                                visibility: visible;
                            }
                        }
                    }
                    &.child-active {
                        .first-nav {
                            font-weight: 600;
                            border-bottom: 2px solid #E30B1B;
                        }
                        &:hover {
                            .first-nav {
                                font-weight: 600;
                                border-bottom: 2px solid #080808;
                            }
                            .second-nav-box{
                                font-weight: 400;
                                visibility: visible;
                            }
                        }
                    }
                    &:hover {
                        font-weight: 600;
                        color: #E30B1B;
                        .second-nav-box{
                            font-weight: 400;
                            visibility: visible;
                        }
                    }
                    .first-nav {
                        display: inline-block;
                        line-height: 30px;
                        height: 30px;
                        // margin-top: 15px;
                        vertical-align: middle;
                        // background: #E30B1B;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateY(-50%) translateX(-50%);
                        white-space: nowrap;
                        border-bottom: 2px solid #080808;
                    }
                    .second-nav-box {
                        // display: none;
                        visibility:hidden;
                        // visibility: visible;
                        padding: 10px 0;
                        background: #080808;
                        font-weight: 400;
                        position: absolute;
                        width: 700px;
                        top: 100%;
                        box-sizing: border-box;
                        padding: 40px 60px;
                        height: 100vw;
                        left: 20px;
                        // display: flex;
                        .second-nav {
                            display: flex;
                            // height: 30px;
                            // line-height: 30px;
                            width: 100%;
                            margin: 0 auto 10px auto;
                            white-space: nowrap;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            &.active {
                                span {
                                    font-weight: 600;
                                    color: #E30B1B;
                                }
                            }
                            span {
                                display: inline-block;
                                height: 30px;
                                line-height: 30px;
                                min-width: 60px;
                                &:hover {
                                    font-weight: 600;
                                }
                            }
                            &:hover {
                                .third-nav-box {
                                    visibility: visible;
                                }
                            } 
                            .third-nav-box {
                                visibility: hidden;
                                height: 100%;
                                position: absolute;
                                left: 260px;
                                top: 40px;
                                width: 78px;
                                font-weight: 400;
                                font-size: 20px;
                                color: #FFFFFF;
                                line-height: 28px;
                                text-align: left;
                                width: 100%;
                                .third-nav {
                                    margin-bottom: 16px;
                                    cursor: pointer;
                                    padding-bottom: 8px;
                                    &.active {
                                        border-bottom: 2px solid #E30B1B;
                                    }
                                    // border-bottom: 1px solid #E30B1B;
                                    &:hover {
                                        span {
                                            // color: #E30B1B;
                                            font-weight: 400;
                                        }
                                    }
                                    span {
                                        font-weight: 300;
                                        color: #FFFFFF;
                                    }
                                }
                            }
                        }
                    }
                    &.personal-nav {
                        .personal {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translateY(-50%) translateX(-50%);
                            img {
                                height: 25px;
                                width: 25px;
                            }
                        }
                    }
                }
            }
        }

        .footer {
            font-size:14px;
            color:rgba(8,8,8,1);
            width: 100%;
            padding: 0;
            .line {
                height: 1px;
                background: #DEDEDE;
                width: 100%;
            }
            .contact {
                width: 1180px;
                box-sizing: border-box;
                height: 140px;
                background:rgba(255,255,255,1);
                margin: 0 auto;
                text-align: center;
                display: flex;
                justify-content: space-between;
                position: relative;
                .left {
                    position: absolute;
                    bottom: 20px;
                    left: 0;
                    // margin-bottom: 20px;
                    .link-box {
                        margin-bottom: 32px;
                        .item {
                            font-size:14px;
                            margin-right: 40px;
                            a:link, a:active, a:visited ,a:hover {
                                color:rgba(102,102,102,1);
                            }

                            &.active {
                                a:link, a:active, a:visited ,a:hover {
                                    color:#080808;
                                    font-weight:600;
                                }
                            }
                            &:hover {
                                a:link, a:active, a:visited ,a:hover {
                                    color:#080808;
                                    font-weight:600;
                                }
                            }
                        }
                    }
                    .address-box {
                        display: flex;
                        height: 44px;
                        text-align: left;
                        .logo {
                            margin-right: 10px;
                            width: 156px;
                            height: 44px;
                            background: #E30B1B;
                            // border:1px solid rgba(8,8,8,1);
                            position: relative;
                            a {
                                display: inline-block;
                                img {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translateX(-50%) translateY(-50%);
                                    width: 103.24px;
                                    height: 17.69px;
                                }
                            }
                        }
                        .address {
                            .text {
                                font-size:14px;
                                color:rgba(8,8,8,1);
                            }
                        }

                    }
                }
                .right {
                    // margin-bottom: 20px;
                    position: absolute;
                    bottom: 20px;
                    right: 0;
                    .bundle {
                        display: inline-block;
                        .phone {
                            margin-bottom: 24px;
                            .strong {
                                font-size:28px;
                                font-weight:600;
                            }
                        }
                        .ex-link-box {
                            display: flex;
                            justify-content: space-between;
                            .ex-link {
                                position: relative;
                                &:hover {
                                    .qr-code {
                                        display: block;
                                    }
                                }
                                .icon {
                                    height: 44px;
                                    width: 44px;
                                }
                                .qr-code {
                                    display: none;
                                    position: absolute;
                                    top: -130px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    z-index: 999;
                                    img {
                                        height: 120px;
                                        width: 120px;
                                    }
                                }
                            }
                        }
                    }
                    .icon-img {
                        width: 98px;
                        height: 98px;
                        margin-left: 10px;
                    }
                }
            }
            .copyright {
                height: 60px;
                text-align: center;
                vertical-align: middle;
                line-height: 60px;
                font-size:14px;
                background:rgba(243,247,250,1);
                .text {
                    color:#A1A1A1;
                }
            }
        }

        // 悬浮标签
        #overflow-tag {
            position: fixed;
            z-index: 9;
            width: 80px;
            background: #fff;
            top: 10%;
            right: 30px;
            box-shadow: 0 10px 20px 2px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
            transform: scaleX(0.8) scaleY(0.8);
            .each-tag {
                position: relative;
                width: 80px;
                height: 90px;
                color: #333;
                background: #fff;
                &.service-tag {
                    border-radius: 10px 10px 0 0;
                }
                &.back-to-top {
                    border-radius: 0 0 10px 10px;
                }
                .right-box {
                    width: 80px;
                    height: 90px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 10px;
                    .icon-img {
                        width: 48px;
                        height: 48px;
                        background-image: url('//cdn.taipuauto.cn/website/sideBtn/wx_logo.png');
                        background-size: 100% 100%;
                    }
                    img {
                        width: 48px;
                        height: 48px;
                        &.red {
                            display: none;
                        }
                    }
                    .line {
                        width: 60px;
                        height: 1px;
                        background: rgba(0, 0, 0, 0.08);
                        margin: 0 auto;
                    }
                }
                &:hover {
                    .right-box {
                        img.gray {
                            display: none;
                        }
                        img.red {
                            display: block;
                        }
                    }
                    .hover-content {
                        display: block;
                    }
                }
                &.back-to-top {
                    width: 80px;
                    height: 78px;
                }
               
                .hover-content {
                    position: absolute;
                    display: none;
                    background: #fff;
                    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.06);
                    border-radius: 4px;
                    top: 0;
                    .tip {
                        color: #333;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    &.kf {
                        left: -132px;
                        width: 122px;
                        padding: 10px;
                        text-align: center;
                        .phone {
                            span {
                                font-size: 20px;
                            }
                        }
                    }
                    &.bdkf {
                        left: -219px;
                        width: 221px;
                        margin-right: -11px;
                        text-align: center;
                        background: transparent;
                        box-shadow: none;
                        padding: 0;
                        padding-right: 11px;
                        .white {
                            background: #fff;
                            padding: 10px;
                            background: #fff;
                            box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.06);
                            border-radius: 4px;
                        }
                        .tip {
                            font-weight: 600;
                            &.btn {
                                width: 100px;
                                margin: 8px auto 0;
                                color: #fff;
                                font-weight: 600;
                                border-radius: 5px;
                                padding: 5px 15px;
                                background: red;
                            }
                        }
                    }

                    &.phone {
                        left: -210px;
                        width: 200px;
                        padding: 10px;
                        padding-left: 15px;
                        text-align: left;
                        .bold {
                            font-weight: 600;
                            font-size: 14px;
                            color: #333;
                            line-height: 24px;
                            margin-bottom: 6px;
                        }
                        .tip>span {
                            color: #888;
                        }
                    }

                    &.follow {
                        padding: 10px;
                        left: -270px;
                        width: 260px;
                        background: #fff;
                        img {
                            width: 112px;
                            height: 112px;
                        }
                        .fl {
                            float: left;
                        }
                        .fr {
                            float: right;
                        }
                    }
                }
            }
        }
	}

    .container-m {
        font-size: .266667rem;
        position: relative;
		top: 0;
		bottom: 0;
		width: 100%;
        padding-top: 1.173333rem;
        .header-box {
            align-items: center;
            width: 100vw;
            height: 1.173333rem;
            background: #080808;
            position: fixed;
            z-index: 202;
            top: 0;
            left: 0;
            padding: 0 .426667rem;
            // border-bottom: 1px solid #D8D8D8;
            .icon-box {
                width: 1.066667rem;
                .icon {
                    width: .533333rem;
                    height: .533333rem;
                }
                .no-login {
                    text-align: right;
                    font-size: 14px;
                }
                .user-icon {
                    width: .533333rem;
                    height: .533333rem;
                }
            }
            .current-nav {
                font-size: 16px;
                color: #ffffff;
                font-weight: 600;
            }
            
            .logo {
                width: 1.973333rem;
                height: .426667rem;
            }

            .side-menu-box {
                width: 100vw;
                height: 100vh;
                background: transparent;
                position: absolute;
                top: 0;
                left: 0;
                // z-index: 300;
                .side-menu {
                    width: 7.466667rem;
                    height: 100vh;
                    background: #232428;
                    box-shadow:0px 5px 5px 0px rgba(0,0,0,0.2);

                }
                .top-logo {
                    width: 100%;
                    height: 2.533333rem;
                    border-bottom: 1px solid #292d31;
                    align-items: center;
                    justify-content: center;
                    img {
                        // width: 23.33%;
                        height: 32px;
                    }
                }
            }
        }

        .footer-img {
            width: 100vw;
        }
        .footer {
            padding-top: 20px;
            background:#080808;
            color:#ffffff;
            font-size:11px;
            padding-bottom: 40px;
            position: relative;
            .tpLogo {
                margin: 0 0 16px 0;
                img {
                    width: 23.33%;
                }
            }
            .link {
                margin: 0 0 24px 0;
                a {
                    display: inline-block;
                    margin-right: 4px;
                    color:#ffffff;
                    &:link,
                    &:hover,
                    &:active,
                    &:visited {
                        text-decoration: none;
                        color:#ffffff;
                    }
                }
                .line {
                    display: inline-block;
                    margin-right: 4px;
                    height: 9px;
                    width: 1px;
                    background: rgba(216,216,216,1);
                }
            }

            .address {
                margin: 0 0 2px 0;
            }

            .email {
                margin: 0 0 16px 0;
            }

            .qrcode {
                // margin-left: 5%;
                text-align: left;
                display: flex;
                align-items: center;
                margin-bottom: 24px;
                img {
                    height: 60px;
                    &:first-child {
                        margin-right: 8px;
                        margin-left: 8px;
                    }
                }
                .phone {
                    flex: 1;
                    margin-left: 20px;
                    text-align: center;
                    .desc {
                        font-size: 11.5px;
                    }
                    .text {
                        font-size:22px;
                        font-weight:500;
                        line-height:31px;
                    }
                }
            }

            .copyright {
                text-align: center;
                font-size: 10px;
                line-height: 40px;
                white-space: nowrap;
                color:#888888;
                height:40px;
                background:rgba(255,255,255,0.1);
                width: 100vw;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>

<style lang="">
    .container .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom-color: transparent !important;
        border-bottom: none !important;
        color: #E30B1B;
    }
    .container .el-menu--horizontal>.el-menu-item.is-active  {
        border-bottom-color: transparent !important;
    }

    .container-m .el-menu {
        background-color: #232428;
        border-right: 0;
    }

    .container-m .el-menu-item {
        width: 1.733333rem;
        margin: 0 auto;
        padding: 0 !important;
        font-size: 16px;
        color: #888888;
    }

    .container-m .el-menu-item.is-active {
        color: #373636;
        font-weight: bold;
        border-bottom: 2px solid #E30B1B;
        font-size: 16px;
        color: #fff;
        font-weight: 600;
    }

    .container-m .el-menu-item, .el-submenu__title {
        height: 36px;
        line-height: 36px;
        margin-bottom: 25px;
        margin-top: 30px;
    }

    .el-dropdown-menu__item--divided:before {
        content: '';
        /* height: 6px; */
        display: block;
        /* margin: 0 -20px; */
        background-color: #FFF;
    }

    .el-dropdown-menu {
        position: absolute;
        left: 0;
        padding: 0 !important;
        margin: 0 !important;
        background-color: #232428;
        border-radius: 4px;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        top: 65px !important;
    }

    .el-dropdown-menu__item--divided {
        position: relative;
        margin-top: 6px;
    }

    .el-popper .popper__arrow::after {
        content: " ";
        border-width: 0 !important;
    }

    .popper__arrow {
        border-width: 0 !important;
        border-bottom-color: #EBEEF5;
    }

    .el-dropdown-menu__item--divided:before {
        content: '';
        height: 0px;
        display: block;
        margin: 0 -20px;
        background-color: #FFF;
    }

    .el-popper[x-placement^=bottom] .popper__arrow {
        top: -6px;
        left: 50%;
        margin-right: 0px;
        border-top-width: 0;
    }

    .el-dropdown-menu__item--divided {
        position: relative;
        margin-top: 0px;
    }

    .el-dropdown-menu__item:hover {
        background: #232428 !important;
        color: #606266 !important;
    }

    .mobile-userinfo-menu {
        top:1.173333rem !important;
        left: auto !important;
        right: 0 !important;
        text-align: center !important;
    }

    .el-message {
        max-width: 70vw !important;
        min-width: 200px !important;
    }

    /* 百度商桥的样式 */
    #newBridge #nb_icon_wrap {
        height: 72px !important;
    }

    #newBridge .nb-icon-skin-0 .nb-icon-inner-wrap {
        background-color: transparent !important;
        width: 2px !important;
        height: 2px !important;
    }
    #newBridge .nb-icon-skin-0 .nb-icon-inner-wrap:hover {
        background-color: #999 !important;
        color: #fff !important;
    }
    #newBridge .icon-right-center {
        width: 2px !important;
        right: -1px !important;
        bottom: 0px !important;
        top: 101 !important;
        margin: 0 !important;
    }
    #newBridge .nb-icon-base .nb-icon-inner-wrap {
        border-radius: 0 !important;
    }

    #newBridge .nb-icon-skin-0 .nb-icon-bridge0 {
        background: none !important;
        height: 2px !important;
    }
    #newBridge .nb-icon-base .nb-icon-bridge-base {
        width: 2px !important;
        margin: 0 !important;
        box-sizing: border-box;
        padding-top: 0px;
        text-align: center;
        top: 0 !important;
        left: 0 !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/Layout.vue